var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"about_us section-padding"},[_c('quienesSomos',{attrs:{"quienesdata":_vm.config}})],1),_vm._v(" "),_c('porqueElegirnos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }